"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.optionalCVOf = exports.someCV = exports.noneCV = void 0;
const clarityValue_1 = require("../clarityValue");
function noneCV() {
    return { type: clarityValue_1.ClarityType.OptionalNone };
}
exports.noneCV = noneCV;
function someCV(value) {
    return { type: clarityValue_1.ClarityType.OptionalSome, value };
}
exports.someCV = someCV;
function optionalCVOf(value) {
    if (value) {
        return someCV(value);
    }
    else {
        return noneCV();
    }
}
exports.optionalCVOf = optionalCVOf;
//# sourceMappingURL=optionalCV.js.map